import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronDown, FiChevronUp } = FiIcons;

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "ทำไมต้องจองล่วงหน้า?",
      answer: "เพราะนักพรตเฮอซานเฉิงต้องใช้เวลาสร้างยันต์ \"ฮู้\" จีนเฉพาะตัวให้แต่ละคน และอาจารย์รวิต้องวิเคราะห์ดวงการเงินของผู้เรียนทุกคนล่วงหน้า เพื่อให้ได้ข้อมูลที่แม่นยำที่สุดในวันเรียน"
    },
    {
      question: "ปาจื้อเป็นแค่ความงมงายไม่ใช่หรือ?",
      answer: "ไม่ใช่เลยครับ ปาจื้อเป็นศาสตร์จีนโบราณที่มีหลักการชัดเจน ใช้หลักธาตุ 5 องค์ประกอบ (ไฟ ดิน โลหะ น้ำ ไม้) และการคำนวณทางคณิตศาสตร์ ดาราศาสตร์ มีการบันทึกและใช้งานมาหลายพันปี ไม่ใช่การเดาหรือความเชื่อแบบงมงาย"
    },
    {
      question: "ยันต์ \"ฮู้\" จีนต่างจากยันต์ทั่วไปอย่างไร?",
      answer: "ยันต์ \"ฮู้\" จีนจะคำนวณเฉพาะจากดวงชะตาของแต่ละคน ไม่ใช่ยันต์ทั่วไป ต้องใช้เวลาสร้างนาน และรับได้ไม่เกิน 20 คนเท่านั้น เพราะนักพรตเฮอซานเฉิงต้องทำด้วยตนเองทุกขั้นตอน ตามหลักโบราณที่ถูกต้อง"
    },
    {
      question: "ผมไม่เชื่อเรื่องพิธีกรรม ยันต์มนต์ จะเรียนได้ไหม?",
      answer: "ได้ครับ เพราะเราสอนหลักการวิเคราะห์ดวงชะตาเป็นหลัก ส่วนพิธีกรรมและยันต์เป็นเพียงเครื่องมือเสริม หากคุณไม่สนใจก็สามารถใช้แค่ความรู้ด้านการวิเคราะห์เพื่อวางแผนการเงินได้ แต่เราจะอธิบายหลักการของทุกอย่างให้เข้าใจ"
    },
    {
      question: "ผู้สอนมีประสบการณ์จริงหรือไม่?",
      answer: "อาจารย์รวิมีประสบการณ์ 18 ปี ในการให้คำปรึกษาด้านธุรกิจและการลงทุนผ่านปาจื้อ ส่วนนักพรตเฮอซานเฉิงเป็นผู้ที่ศึกษาพิธีกรรมโบราณมาอย่างลึกซึ้ง การรวมตัวของทั้งสองท่านทำให้ได้ทั้งทฤษฎีและปฏิบัติที่สมบูรณ์"
    },
    {
      question: "ต้องมีพื้นฐานเรื่องปาจื้อมาก่อนไหม?",
      answer: "ไม่ต้องครับ เราจะสอนตั้งแต่พื้นฐาน และเน้นไปที่การประยุกต์ใช้จริง ไม่ใช่ทฤษฎีที่ซับซ้อน คุณจะเรียนรู้แบบ step by step และได้ฝึกปฏิบัติกับดวงชะตาของตัวเองเลย"
    },
    {
      question: "หากเรียนแล้วไม่เห็นผลจะทำอย่างไร?",
      answer: "ความรู้ที่ได้จะใช้ได้ตลอดชีวิต และเราจะสอนให้คุณวิเคราะห์ดวงตัวเองได้ ส่วนผลลัพธ์ขึ้นอยู่กับการนำไปใช้ด้วย แต่อย่างน้อยคุณจะรู้ว่าช่วงไหนควรระวัง ช่วงไหนเหมาะสมลงทุน ซึ่งจะช่วยลดความเสี่ยงได้แน่นอน"
    },
    {
      question: "ทำไมจำกัดแค่ 35 คน?",
      answer: "เพื่อให้การสอนมีคุณภาพ เราต้องคำนวณดวงชะตาและสร้างยันต์ให้แต่ละคนเป็นรายบุคคล หากมีคนมากเกินไปจะไม่สามารถให้ความเอาใจใส่เฉพาะบุคคลได้ครบถ้วน นอกจากนี้ยันต์ \"ฮู้\" จีนรับได้ไม่เกิน 20 คนแรก"
    },
    {
      question: "ราคา 5,500 บาท คุ้มค่าไหม?",
      answer: "หากคิดจากสิ่งที่ได้รับ (ความรู้จาก 2 ผู้เชี่ยวชาญ + การวิเคราะห์ส่วนตัว + ยันต์ \"ฮู้\" จีน + ปฏิทินฤกษ์) หากไปหาที่อื่นจะต้องจ่ายมากกว่า 50,000 บาท และใช้ได้ตลอดชีวิต ถือว่าคุ้มค่ามาก"
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 px-4 relative overflow-hidden">
      {/* Enhanced Background */}
      <div className="absolute inset-0 opacity-20">
        <img 
          src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751395134810-20240213_085721.jpg" 
          alt="Background" 
          className="absolute top-0 left-0 w-1/2 h-full object-cover rounded-r-3xl" 
        />
        <img 
          src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751395147479-blob" 
          alt="Background" 
          className="absolute bottom-0 right-0 w-1/2 h-2/3 object-cover rounded-tl-3xl opacity-70" 
        />
      </div>
      
      <div className="container mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            คำถามที่พบบ่อย
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            ตอบทุกข้อสงสัยก่อนตัดสินใจ
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="bg-slate-800/50 backdrop-blur-sm rounded-xl border border-slate-600/30 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full p-6 text-left flex justify-between items-center hover:bg-slate-700/30 transition-all duration-300"
              >
                <h3 className="text-lg font-semibold text-white pr-4">
                  {faq.question}
                </h3>
                <SafeIcon
                  icon={openIndex === index ? FiChevronUp : FiChevronDown}
                  className="text-amber-400 text-xl flex-shrink-0"
                />
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="p-6 pt-0 border-t border-slate-600/20">
                      <p className="text-slate-300 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-center mt-12"
        >
          <div className="bg-gradient-to-r from-blue-500/20 to-indigo-600/20 rounded-xl p-8 border border-blue-500/30 max-w-3xl mx-auto">
            <h3 className="text-xl font-bold text-blue-400 mb-4">
              ยังมีคำถามอื่นๆ?
            </h3>
            <p className="text-slate-300 mb-4">
              โทรสอบถามได้ที่ <span className="text-amber-400 font-semibold">098-850-5900</span>
            </p>
            <p className="text-sm text-slate-400">
              เราพร้อมตอบทุกข้อสงสัยก่อนที่คุณจะตัดสินใจ
            </p>
            <div className="mt-4 p-3 bg-slate-700/40 backdrop-blur-md rounded-lg border border-slate-600/30">
              <p className="text-slate-300 font-medium text-sm">
                ⏰ ใกล้ปิดรับสมัครแล้ว!
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;